/**
 * Patch for angular-datatables which provides debounced search functionality
 */
angular
    .module("datatables.fieldsSearch", ["datatables"])
    .config(function () {
    // Search function
    $.fn.dataTable.Api.register("fieldsSearch()", function (searchInput) {
        this.iterator("table", function (context) {
            context._searchInput = searchInput;
            context.oInstance.api().search(searchInput);
        });
        return this;
    });
    $.fn.dataTable.FieldsSearch = function (context) {
        var table = new $.fn.dataTable.Api(context);
        var container = $('<div class="fields-search"/>');
        var input = $('<input class="userField" type="text" placeholder="Enter search criteria" />');
        $('<span class="search_box"><img src="/public/images/magnify.svg" /></span>').appendTo(container);
        function update(event) {
            table.fieldsSearch(input.val()).draw();
        }
        //TODO move debouncing constant to config
        input.on("input", _.debounce(update, 350));
        input.appendTo(container);
        table.fieldsSearch('');
        // API method to get the alphabet container node
        this.node = function () {
            return container;
        };
    };
    $.fn.DataTable.FieldsSearch = $.fn.dataTable.FieldsSearch;
    // Register a search plug-in
    $.fn.dataTable.ext.feature.push({
        fnInit: function (settings) {
            if (!settings.oInit.fieldsSearch !== false) {
                var search = new $.fn.dataTable.FieldsSearch(settings);
                return search.node();
            }
        },
        cFeature: "F"
    });
});

//# sourceMappingURL=datatables-search.plugin.js.map
